<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
<!--          <div class="card-header">-->
<!--            <h4 class="card-title pull-left">-->
<!--              Signup Logs-->
<!--            </h4>-->
<!--          </div>-->
          <div class="card-body">
            <div class="loader" v-if="loading"></div>
            <table v-else class="table table-striped table-responsive task-table job-signup-logs-datatable">
              <thead>
              <tr>
                <th >SESSION ID</th>
                <th >SESSION CREATED TIME</th>
                <th class="text-center">EMAIL</th>
                <th class="text-center">DOMAIN</th>
                <th class="text-center">CART ITEMS</th>
                <th class="text-center">CART TOTAL AMOUNT</th>
                <th class="text-center">ORDER ID</th>
                <th class="text-center">ORDER DATE/TIME</th>
                <th class="text-center" title="Terms of service agreement data/time">TOS Time</th>
                <th class="text-center">Customer IP</th>
                <th class="text-center">STATUS</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(log, index) in logs" :key="log.sessId + index">
                <td>
                  <small class="text-black"><b>{{log.sessId}}</b></small>
                </td>
                <td class="text-center">
                  <small v-if="log.createdTime" class="text-black"><b><span >{{log.createdTime | formatDate}}</span></b></small>
                </td>
                <td width="10%" class="text-center">
                  <small class="text-black"><b>{{log.email}}</b></small>
                </td>
                <td width="10%" class="text-center">
                  <small class="text-black"><b>{{log.domain}}</b></small>
                </td>
                <td class="text-center" width="15%">
                  <div v-for="(item, i_index) of log.cartItems.filter(el => el.name)" :key="i_index">
                    <small>
                      <div class="badge badge-primary">
                        {{item.name}}
                      </div><br/>
                      <!--                    <span v-if="item.extraSite" class="badge badge-primary"> {{item.extraSite}} Extras </span>-->
                      <div v-if="item.extraSite" class="badge badge-primary">
                        {{item.extraSite}} Additional Sites
                      </div>
                    </small>
                  </div>
                </td>
                <td class="text-center">
                  <small class="text-black"><b>${{log.cartTotalAmount}}</b></small>
                </td>
                <td class="text-center">
                  <small class="text-black"><b>
                    <a :href="`https://portal.bigscoots.com/admin/index.php?cmd=orders&action=edit&id=${log.orderId}`" target="_blank">
                      {{log.orderId}}
                    </a>
                  </b></small>
                </td>
                <td class="text-center">
                  <small v-if="log.orderTime" class="text-black"><b>{{log.orderTime | formatDate}}</b></small>
                </td>
                <td class="text-center">
                  <small v-if="log.tosTime" class="text-black"><b>{{log.tosTime | formatDate}}</b></small>
                </td>
                <td class="text-center">
                  <small class="text-black"><b>{{log.customerIP}}</b></small>
                </td>
                <td class="text-center">
                  <small class="text-black"><b><span class="badge " :class="log.status === 'success' ? 'badge-success' : 'badge-warning'">{{log.status}}</span></b></small>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import swal from 'sweetalert2';
import moment from "moment";
export default {
  name: "logs",
  data() {
    return {
      logs: [],
      loading: true,
      deleting: false,
      adding: false,
      fixLoader: false,
      selectedIndex: -1,
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  mounted () {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
    this.getSignupLogs();
  },
  methods: {
    doCopy(item){
      this.$copyText(item).then(() => {
        this.$notify({
          group: 'foo',
          title: 'Message',
          text: 'Copied!'
        });
      }, function (e) {
        console.log(e)
      });
    },
    fixModal() {
      /* eslint-disable */
      $(document).ready(function() {
        $(".modal-backdrop").appendTo(".new-announcement-modal");
      });
      /* eslint-enable */
    },
    getSignupLogs () {
      this.logs = [];
      $(".job-signup-logs-datatable").DataTable().destroy();
      const announcementQuery = db.collection('signup-logs').orderBy('createdTime', "desc");
      announcementQuery.get().then(docs => {
        let ann = [];
        docs.forEach(doc => {
          ann.push({id: doc.id, ...doc.data()});
        });
        this.logs = ann;
      }).finally(() => {
        this.loading = false;
        this.initDataTable();
      })

    },
    initDataTable () {
      /* eslint-disable */
      $(document).ready(function () {
        $(".job-signup-logs-datatable").DataTable({
          destroy: true,
          retrieve: true,
          deferRender: true,
          "ordering": false,
          stateSave: true,
          language: {
            search: "_INPUT_",
            searchPlaceholder: "Search",
            emptyTable: "No signup logs exist in the system",
            size: '40'
          }
        });
        $('#newAnnouncementModal').modal('hide');
      });
      /* eslint-enable */
    },
  }
}
</script>

<style scoped>
th{
  font-size: 12px !important;
  font-weight: bold !important;
}
</style>